import React, { useState, useEffect, useContext, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import notificationstyles from "src/Assets/css/notications/notifications.module.css";
import styles from "src/Assets/css/home/post.module.css";
import dropdownarrow from "src/Assets/images/pulldown.svg";
import removenotitifcationicon from "src/Assets/images/removenotitifcationicon.svg";
import { CircularProgress } from "@material-ui/core";
import API from "../../network";
import * as notificationActions from "src/store/actions/notificationsactions/notificationActionCreator";
import AvatarBadge from "src/Components/AvatarBadge";
// import TextWithUrlsAndHashTags from "src/Components/TextWithUrlsAndHashTags";
import TextWithUrlsHashTagsForNotification from "src/Components/TextWithUrlsAndHashTags/TextWithUrlsHashTagsForNotification";
import {
  CommonModalContext,
  ModalType,
} from "src/context/CommonModalContext/CommonModalContext";
import AnswerAndReplyNotificationModal from "./AnswerAndReplyNotificationModal/AnswerAndReplyNotificationModal";
import ConfirmationDialog from "src/Components/ConfirmationDialog";
import * as SignInActions from "src/store/actions/SignInActions/SignInAction";
import BlockedAndWarningNotificationModal from "./AnswerAndReplyNotificationModal/BlockedAndWarningNotification";

const Notifications = ({
  notificationListPage,
  setNotificationListPage,
  setIsNotificationLoading,
  setHasMoreNotifications,
}) => {
  const notificationReducerData = useSelector(
    (state) => state.notificationReducer.notificationData,
  );
  const userDetails = useSelector((state) => state?.SignInReducer?.userDetails);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("all");
  const [openAnswerAndReplyModal, setOpenAnswerAndReplyModal] = useState(false);
  const [ansAndReplyKeword, setAnsAndReplyKeword] = useState("");
  const [tagName, setTagName] = useState(null);
  const [flaggedReason, setFlaggedReason] = useState("");
  const [notificationId, setNotificationId] = useState(null);
  const [senderId, setSenderId] = useState(null);
  const [answerAndReplyMessageData, setAnswerAndReplyMessageData] = useState(
    [],
  );
  const [confModalVisible, setConfModalVisible] = useState(null);
  const [
    blockedAndWarningNotificationPostDetail,
    setBlockedAndWarningNotificationPostDetail,
  ] = useState({
    isModelOpen: false,
    blockedAndWarningNotificationData: null,
  });
  const [ansOrReplyLoading, setAnsOrReplyLoading] = useState(false);
  const commonModalContext = useContext(CommonModalContext);
  const [notificationData, setNotificationData] = useState(
    notificationReducerData,
  );
  var profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  const fetchNotifications = useCallback(
    async (filterType) => {
      const offset = (notificationListPage - 1) * 10;
      const isFirstPage = notificationListPage === 1;

      try {
        if (isFirstPage) {
          setLoading(true); // full-page loader only for first load
        } else {
          setIsNotificationLoading(true); // bottom loader for scroll
        }
        const encodedFilter = encodeURIComponent(filterType);
        const response = await API.fetchNotifications(encodedFilter, offset);
        const resData = response?.data || {};
        const newList = resData?.notificationList || [];

        if (isFirstPage) {
          setNotificationData(resData);
          dispatch(notificationActions.receiveNotificationData(resData));
          if (newList.length < 10) {
            setHasMoreNotifications(false);
          } else {
            setHasMoreNotifications(true);
          }
        } else {
          if (newList.length > 0) {
            setNotificationData((prevData) => {
              const prevList = prevData?.notificationList || [];
              const updatedList = [...prevList, ...newList];
              const updatedData = {
                ...prevData,
                ...resData,
                notificationList: updatedList,
              };
              dispatch(
                notificationActions.receiveNotificationData(updatedData),
              );
              return updatedData;
            });
            if (newList.length < 10) {
              setHasMoreNotifications(false);
            }
          } else {
            setHasMoreNotifications(false);
          }
        }
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      } finally {
        if (isFirstPage) {
          setLoading(false);
        } else {
          setIsNotificationLoading(false);
        }
      }
    },
    [
      notificationListPage,
      dispatch,
      setHasMoreNotifications,
      setIsNotificationLoading,
    ],
  );

  useEffect(() => {
    const filterType = filter === "all" ? "" : filter;
    fetchNotifications(filterType);
  }, [notificationListPage, filter, fetchNotifications]);
  const onClose = () => {
    setConfModalVisible(null);
  };

  const handleCloseBlockedAndWarningModal = () => {
    setBlockedAndWarningNotificationPostDetail((prev) => ({
      ...prev,
      isModelOpen: false,
    }));
  };

  const handleFollow = async (commId, commName, id) => {
    let formdata = new FormData();
    formdata.append("communityID", commId);
    formdata.append("communityName", commName);
    formdata.append("followStat", 1);
    formdata.append("sourceApp", "WebApp");
    await API.followUnfollowCommunity(formdata)
      .then((res) => {
        if (res?.data?.status) {
          setConfModalVisible({
            open: true,
            type: "success",
            title: res?.data?.status,
            acceptLabel: "Ok",
            onAccept: onClose,
          });
          onRemoveNotificationFromStateList(id);
          dispatch(SignInActions.fetchloginUser());
        }
      })
      .catch((err) => {});
  };

  const fetchAnswerAndReplyMessageData = async (answerAndReplyMessageId) => {
    setAnswerAndReplyMessageData([]);
    try {
      setAnsOrReplyLoading(true);
      const response = await API.showNotificationParentPost(
        answerAndReplyMessageId,
      );
      if (response?.data?.messageFeed?.length > 0) {
        setAnswerAndReplyMessageData(response.data.messageFeed);
      }
      setAnsOrReplyLoading(false);
    } catch (error) {
      console.error("Error in fetching data:", error);
      alert("Failed to fetch data. Please try again.");
      setAnsOrReplyLoading(false);
    }
  };

  const onCloseAnswerAndReplyModal = () => {
    setOpenAnswerAndReplyModal(false);
  };

  const likeUnlike = (id) => {
    const newData = [...answerAndReplyMessageData];
    const modifiedData = newData.find((x) => x.message_id === id);
    modifiedData.UserLikeStatus = "inactive";
    modifiedData.vote_up_count = modifiedData.vote_up_count - 1 + 2;
    setAnswerAndReplyMessageData(newData);
  };

  const updateMessage = (id, message, locationName) => {
    const newData = [...answerAndReplyMessageData].map((eachItem) => {
      if (eachItem?.message_id === id) {
        return {
          ...eachItem,
          message_text: message,
          loc_name: locationName,
        };
      }
      return { ...eachItem };
    });
    setAnswerAndReplyMessageData(newData);
  };

  const updateNewSelectedLocation = (newSelectedLoc) => {
    const newData = [...answerAndReplyMessageData];
    const modifiedData = newData[0];
    if (modifiedData) {
      modifiedData.newSelectedLocation = newSelectedLoc; // Added a temporary key-value pair
    }
    setAnswerAndReplyMessageData(newData);
  };

  const removeNewSelectedLocationKey = () => {
    const newData = answerAndReplyMessageData.map((item) => {
      // Create a copy of the object without mutating the original
      const { newSelectedLocation, ...rest } = item; // Destructure and exclude the temporary key
      return rest; // Return the object without the temporary key
    });
    setAnswerAndReplyMessageData(newData); // Update the state with the cleaned array
  };

  const deleteAnsOrReplyPost = (id) => {
    let formdata = new FormData();
    formdata.append("messageID", id);
    API.deleteProfilePost(formdata)
      .then((res) => {
        const newList = [...answerAndReplyMessageData];
        const index = newList.findIndex((x) => x.message_id === id);
        if (index > -1) {
          newList.splice(index, 1);
          setAnswerAndReplyMessageData(newList);
        }
        setOpenAnswerAndReplyModal(false);
      })
      .catch((err) => {});
  };

  const onFilterSelection = (e) => {
    e.preventDefault();
    setFilter(e.target.value);
    setNotificationData((prevData) => ({
      ...prevData,
      notificationList: [],
    })); // clear previous list
    setNotificationListPage(1); // start from first page
    setHasMoreNotifications(true); // allow scrolling again
  };

  const getFormData = (
    tenantId,
    messageId,
    category,
    requestType,
    senderId,
  ) => {
    let approveIdsValue = "";
    const loggedInUserId = userDetails?.userData?.User_ID;
    if (category === "F") {
      approveIdsValue = `abs_${messageId}`;
    } else if (category === "RQC") {
      approveIdsValue = `user_${senderId}_${tenantId}`;
    } else if (category === "RQM") {
      approveIdsValue = `user_${loggedInUserId}_${tenantId}`;
    }

    approveIdsValue =
      requestType === "approve"
        ? `${approveIdsValue}_1`
        : `${approveIdsValue}_0`;
    console.info(approveIdsValue);

    let formData = new FormData();
    formData.append("approveIds", approveIdsValue);
    return formData;
  };

  const viewNotification = async (status, id) => {
    if (status === "unread" || status === null) {
      try {
        const response = await API.getNotificationStatus(id);
        console.log(`view response data:`, response);

        if (response?.data?.status === "Success") {
          const updatedList = (notificationData.notificationList || []).map(
            (each) =>
              each.id === id
                ? { ...each, viewstatus: "read" } // update status to "read"
                : each,
          );

          const updatedNotifications = {
            ...notificationData,
            notificationList: updatedList,
          };

          setNotificationData(updatedNotifications);
          dispatch(notificationActions(updatedNotifications));
        }
      } catch (e) {
        console.error("Error updating notification view status:", e);
      }
    }
  };
  const approveAction = async (messageId, category, tenantId, senderId, id) => {
    try {
      const formData = getFormData(
        tenantId,
        messageId,
        category,
        "approve",
        senderId,
      );
      if (category === "RQPM") {
        const res = await API.primaryModeratorApproveDeny(tenantId, 1);
        if (res?.data?.status) {
          setConfModalVisible({
            open: true,
            type: "success",
            title: res?.data?.status,
            acceptLabel: "Ok",
            onAccept: onClose,
          });
          onRemoveNotificationFromStateList(id);
        }
      } else {
        const res = await API.moderatorApproveDeny(formData);
        if (res?.data?.status) {
          setConfModalVisible({
            open: true,
            type: "success",
            title: res?.data?.status,
            acceptLabel: "Ok",
            onAccept: onClose,
          });
          onRemoveNotificationFromStateList(id);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onReject = async (messageId, category, tenantId, senderId, id) => {
    try {
      const formData = getFormData(
        tenantId,
        messageId,
        category,
        "reject",
        senderId,
      );
      if (category === "RQPM") {
        const res = await API.primaryModeratorApproveDeny(tenantId, 0);
        if (res?.data?.status) {
          setConfModalVisible({
            open: true,
            type: "success",
            title: res?.data?.status,
            acceptLabel: "Ok",
            onAccept: onClose,
          });
          onRemoveNotificationFromStateList(id);
        }
      } else {
        const res = await API.moderatorApproveDeny(formData);
        if (res?.data?.status) {
          setConfModalVisible({
            open: true,
            type: "success",
            title: res?.data?.status,
            acceptLabel: "Ok",
            onAccept: onClose,
          });
          onRemoveNotificationFromStateList(id);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onRemoveNotificationFromStateList = (id) => {
    const updatedNotificationsList = notificationData?.notificationList?.filter(
      (each) => each.id !== id,
    );
    const updatedNotifications = {
      ...notificationData,
      notificationList: updatedNotificationsList,
    };
    setNotificationData(updatedNotifications);
  };

  const onRemoveNotification = async (id) => {
    try {
      await API.removeNotification(id);
      const updatedNotificationsList =
        notificationData?.notificationList?.filter((each) => each.id !== id);
      const updatedNotifications = {
        ...notificationData,
        notificationList: updatedNotificationsList,
      };
      setNotificationData(updatedNotifications);
      dispatch(notificationActions(updatedNotifications));
    } catch (e) {
      console.error(e);
    }
  };


  const onViewStatus = (
    status,
    id,
    parentId,
    messageId,
    keyword,
    tagName,
    flaggedReason,
    senderId,
    notificationdata,
  ) => {
    // 1. Mark as read
    viewNotification(status, id);

    // 2. Highlight the clicked notification
    const element = document.getElementById(id);
    if (element) {
      element.style.backgroundColor = "rgb(243 242 240 / 43%)";
    }

    // 3. Open parent post modal
    const parentMsgId = parentId || messageId;

    if (
      keyword === "S" ||
      keyword === "I" ||
      keyword === "A" ||
      keyword === "X" ||
      keyword === "H"
    ) {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, {
        parentMsgId,
      });
    }
    if (keyword === "W" || keyword === "P" || keyword === "F") {
      fetchAnswerAndReplyMessageData(messageId);
      setAnsAndReplyKeword(keyword);
      setTagName(tagName);
      setOpenAnswerAndReplyModal(true);
      setFlaggedReason(flaggedReason);
      setSenderId(senderId);
      setNotificationId(id);
    }
    if (keyword === "BL" || keyword === "WRN") {
      setBlockedAndWarningNotificationPostDetail((prev) => ({
        ...prev,
        isModelOpen: true,
        blockedAndWarningNotificationData: notificationdata,
      }));
    }
  };

  const onRemove = (id) => {
    onRemoveNotification(id);
    document.getElementById(id).style.display = "none";
    setOpen(false);
  };

  const sortedNotifications = notificationData.notificationList
    ? [...notificationData.notificationList].sort(
        (a, b) => new Date(b.Message_Time) - new Date(a.Message_Time),
      )
    : [];

  console.log(`sortedNotifications:`, sortedNotifications);

  return (
    <>
      {!loading &&
      notificationData &&
      Object.keys(notificationData).length !== 0 ? (
        <div className={notificationstyles.notificationMainContainer}>
          <div className={notificationstyles.filterdropdown}>
            <h5>Notifications</h5>
            <select
              onChange={(e) => onFilterSelection(e)}
              value={filter}
              className={notificationstyles.selectpulldown}
            >
              <option value="all">Show: All</option>
              <option value="ask">ASK</option>
              <option value="say">SAY</option>
              <option value="update">UPDATE</option>
              <option value="tag">TAG</option>
              <option value="answer">Answer</option>
              <option value="reply">Reply</option>
              <option value="moderator">Moderator</option>
            </select>
          </div>

          {sortedNotifications.length !== 0 ? (
            sortedNotifications.map((notificationdata) => (
              <div
                className={`${
                  notificationdata.viewstatus === "read"
                    ? notificationstyles.notificationbody
                    : notificationstyles.unreadnotification
                }`}
                style={{ cursor: "pointer" }}
              >
                <div
                  className={notificationstyles.notificationPost}
                  onClick={() =>
                    onViewStatus(
                      notificationdata?.viewstatus,
                      notificationdata?.id,
                      notificationdata?.parentId,
                      notificationdata?.messageId,
                      notificationdata?.keyword,
                      notificationdata?.hash_tag_name,
                      notificationdata?.reason,
                      notificationdata?.senderID,
                      notificationdata,
                    )
                  }
                  key={notificationdata.id}
                  id={notificationdata.id}
                >
                  <div className={notificationstyles.notificationmessagebody}>
                    <div>
                      <AvatarBadge
                        // src={`${profileImagePath}${notificationdata.uimage}`}
                        src={
                          notificationdata.uimage
                            ? `${profileImagePath}${notificationdata.uimage}`
                            : process.env.REACT_APP_DUMMY_PROFILE_IMAGE
                        }
                        variant="rounded"
                        className={notificationstyles.avatarimage}
                        isPrimaryModerator={
                          String(notificationdata?.mainuserdata?.isModerator) === "1" &&
                          String(notificationdata?.mainuserdata?.isPM) === "1"
                        }
                        isModerator={
                          String(notificationdata?.mainuserdata?.isModerator) === "1" &&
                          String(notificationdata?.mainuserdata?.isPM) !== "1"
                        }
                      />
                    </div>
                    <div className={notificationstyles.mesageandtime}>
                      {/* <p
                        dangerouslySetInnerHTML={{ __html: notificationdata.Message }}
                        className={notificationstyles.msgTxt}
                      ></p> */}
                      <div className={notificationstyles.msgTxt}>
                        <TextWithUrlsHashTagsForNotification
                          Message={notificationdata?.Message}
                          text={notificationdata?.msg}
                          displayName={notificationdata?.displayName}
                          hashtags={notificationdata?.tag}
                          urls={notificationdata?.url}
                          onHashtagClick={() => {}}
                        />
                      </div>
                      <p className={notificationstyles.messagetime}>
                        {notificationdata.Message_Time} ago in{" "}
                        {notificationdata.tenantName}
                      </p>
                    </div>
                  </div>

                  <div className={`${styles.dropdown}`}>
                    <div
                      className={`${
                        notificationdata.viewstatus === "read"
                          ? notificationstyles.notificationdropdown
                          : notificationstyles.unreadnotificationdropdown
                      }`}
                      id={notificationdata.id}
                    >
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation(); // Stops the parent div's onClick from firing
                          setOpen(true);
                        }}
                        className={notificationstyles.dropDownBtn}
                      >
                        <img src={dropdownarrow} alt="dropdown" />
                      </button>
                    </div>

                    {open && (
                      <div
                        className={`${styles.dropdownlinks} ${notificationstyles.notificationdropdownlinks}`}
                      >
                        <ul>
                          <li>
                            <button
                              type="button"
                              className={notificationstyles.removenotifiction}
                              onClick={(e) => {
                                e.stopPropagation(); // Prevents parent div's onClick from firing
                                onRemove(notificationdata.id);
                              }}
                            >
                              <img
                                src={removenotitifcationicon}
                                alt="removenotification"
                              />
                              <span>Remove this notification </span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
                {notificationdata?.keyword === "RQFC" && (
                  <div className={notificationstyles.followBtnContainer}>
                    <button
                      onClick={() =>
                        handleFollow(
                          notificationdata?.tenantID,
                          notificationdata?.tenantName,
                          notificationdata.id,
                        )
                      }
                    >
                      Follow
                    </button>
                  </div>
                )}
                {(notificationdata?.keyword === "RQC" ||
                  notificationdata?.keyword === "RQM" ||
                  notificationdata?.keyword === "RQPM") && (
                  <div className={notificationstyles.AcceptRejectBtnContainer}>
                    <button
                      className={notificationstyles.AcceptRejectBtn}
                      onClick={() =>
                        approveAction(
                          notificationdata?.messageId,
                          notificationdata?.keyword,
                          notificationdata?.tenantID,
                          notificationdata?.senderID,
                          notificationdata?.id,
                        )
                      }
                    >
                      Accept
                    </button>
                    <button
                      className={notificationstyles.AcceptRejectBtn}
                      onClick={() =>
                        onReject(
                          notificationdata?.messageId,
                          notificationdata?.keyword,
                          notificationdata?.tenantID,
                          notificationdata?.senderID,
                          notificationdata?.id,
                        )
                      }
                    >
                      Reject
                    </button>
                  </div>
                )}
                {/* {notificationdata?.keyword === "F" && (
                  <div className={notificationstyles.AcceptRejectBtnContainer}>
                    <button
                      className={notificationstyles.AcceptRejectBtn}
                      onClick={() =>
                        onReject(
                          notificationdata?.messageId,
                          notificationdata?.keyword,
                          notificationdata?.tenantID,
                          notificationdata?.senderID,
                          notificationdata?.id
                        )
                      }
                    >
                      Ignore
                    </button>
                    <button
                      className={notificationstyles.AcceptRejectBtn}
                      onClick={() =>
                        approveAction(
                          notificationdata?.messageId,
                          notificationdata?.keyword,
                          notificationdata?.tenantID,
                          notificationdata?.senderID,
                          notificationdata?.id
                        )
                      }
                    >
                      Remove
                    </button>
                  </div>
                )} */}
              </div>
            ))
          ) : (
            <div className={notificationstyles.noDataContainer}>
              <p>No data found</p>
            </div>
          )}
        </div>
      ) : (
        <>
          {loading ? (
            <CircularProgress className={notificationstyles.loader} />
          ) : (
            <div className={notificationstyles.noDataContainer}>
              <p>You have no notifications yet.</p>
            </div>
          )}
        </>
      )}
      <AnswerAndReplyNotificationModal
        openAnswerAndReplyModal={openAnswerAndReplyModal}
        onCloseAnswerAndReplyModal={onCloseAnswerAndReplyModal}
        ansOrReplyLoading={ansOrReplyLoading}
        answerAndReplyMessageData={answerAndReplyMessageData}
        ansAndReplyKeword={ansAndReplyKeword}
        onDelete={deleteAnsOrReplyPost}
        likeUnlike={likeUnlike}
        updateMessage={updateMessage}
        updateNewSelectedLocation={updateNewSelectedLocation}
        removeNewSelectedLocationKey={removeNewSelectedLocationKey}
        tagName={tagName}
        flaggedReason={flaggedReason}
        onReject={onReject}
        approveAction={approveAction}
        notificationId={notificationId}
        senderId={senderId}
      />
      <BlockedAndWarningNotificationModal
        blockedAndWarningNotificationData={
          blockedAndWarningNotificationPostDetail?.blockedAndWarningNotificationData
        }
        isModelOpen={blockedAndWarningNotificationPostDetail?.isModelOpen}
        handleCloseBlockedAndWarningModal={handleCloseBlockedAndWarningModal}
        filterType="blockedOrWarningNotification"
      />
      {confModalVisible?.open && <ConfirmationDialog {...confModalVisible} />}
    </>
  );
};

export default Notifications;
